import { Component } from '@angular/core';

@Component({
    selector: 'app-detail-activity',
    templateUrl: './detail-activity.component.html',
    styleUrls: ['./detail-activity.component.scss'],
})
export class DetailActivityComponent {}
